import emitter from 'garden/src/js/utils/emitter'

export const updateCartReference = data =>
  emitter.emit('mini-cart:saga-update-shipping', data)

export const serviceHasUpdated = data =>
  emitter.emit('cart:service-change', data)

export const updateCartShipping = () =>
  emitter.emit('cart:products-replace')
